<template lang="pug">
    v-dialog(v-model="isOpen" :max-width="width") {{ isOpen }}
        v-card(v-if="content.title")

            // Title
            v-card-title.promptTitle(v-if="content.title") {{ content.title }}

            // Description
            v-card-text(v-if="content.description") {{ content.description }}

            v-divider.my-3

            // Actions
            v-card-actions.propmptControls

                div
                    // Decline button
                    v-btn.reject(
                        @click="reject"
                        color="grey lighten-1"
                        outlined
                        large
                        v-if="content.declineButton"
                    ) {{ content.declineButton }}

                div
                    // Confirm button
                    v-btn.confirm(
                        @click="confirm"
                        color="primary"
                        large
                        v-if="content.confirmButton"
                    ) {{ content.confirmButton }}
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        computed: {
            ...mapState('prompt', ['confirmed', 'content', 'width']),
            isOpen: {
                get() {
                    return this.$store.state.prompt.show;
                },
                set(value) {
                    value ? this.show() : this.reject();
                },
            },
        },
        methods: {
            ...mapActions('prompt', ['show', 'confirm', 'reject']),
        },
    };
</script>

<style lang="stylus" scoped>
    @import '../../assets/style/_variables.styl'

    .promptTitle
        font-size: 28px
        font-weight: 700
        padding-bottom: 0

    .propmptControls
        display: flex
        justify-content: space-between

    .v-card__actions
        padding: 16px

    .spacer
        height: 1px
        margin: 0 16px
        background-color: $theme.grey

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .propmptControls > div  .btn.v-btn
            padding: 0 30px
</style>
